<template lang="">
	<div id="content">
		<div class="global_area">
			<div class="path"><a href="#none">Home</a> &gt; <a href="#none">기타 관리</a> &gt; <strong>문의내역</strong></div>
			<h2 class="h_sub">문의내역</h2>
		</div>

    <InquiryAnswerForm/>
  </div>
</template>

<script>
import InquiryAnswerForm from '@/components/admin/etc/InquiryAnswerForm.vue';

export default {
  components: {
    InquiryAnswerForm
  }
}
</script>
<style lang="">
    
</style>